function UsInNumbers() {
    return ( 
        <>
            <section className="us-in-numbers">
                <div className="container">
                    <div className="heading">
                        Some of our stats
                    </div>
                    <div className="row">
                        <div className="col-6 col-md-6 col-lg-3">
                            <div className="number-max">
                                92
                            </div>
                            <div className="number-desc">
                                Successful cases
                            </div>
                        </div>
                        <div className="col-6 col-md-6 col-lg-3">
                            <div className="number-max">
                                6+
                            </div>
                            <div className="number-desc">
                                Years of experience
                            </div>
                        </div>
                        <div className="col-6 col-md-6 col-lg-3">
                            <div className="number-max">
                                11+
                            </div>
                            <div className="number-desc">
                                Models in our team
                            </div>
                        </div>
                        <div className="col-6 col-md-6 col-lg-3">
                            <div className="number-max">
                                10k$
                            </div>
                            <div className="number-desc">
                                an average profit per model
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
     );
}

export default UsInNumbers;